module.exports = __webpack_public_path__ + "fonts/7188ef69d4bb4372445f7824680b100f.svg";